module.exports = __webpack_public_path__ + "static/media/pending.5badd239.svg";